const dev = false;
const localHost = "http://wst.qihe.local";
const proHost = "//wst-api.zj-qq.cn";
const devHost = dev ? localHost : proHost;
export const HOST = process.env.NODE_ENV === "production" ? proHost : devHost;
export const TOKEN_EXPIRE = 12 * 60 * 60 * 1000; // token 有效期
export const IDLE_TIME = 120; // 多长时间未操作返回首页 单位 s
export const ORDER_TIMEOUT = 90; // 订单未支付超时时间 单位 s
